import { ModalProps } from "antd";
import { ReactNode } from "react";

export const USER_ROLES = {
  SUPER_ADMIN: "superadmin",
  ADMIN: "admin",
  USER: "user",
} as const;
export type TUserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export type CommonStatus = "Active" | "Inactive";

// custom modal props
export interface CustomModalProps extends ModalProps {
  title?: string;
  open: boolean;
  centered?: boolean;
  className?: string;
  disableCloseButton?: boolean;
  handleClose?: (val?: any) => void;
  children?: ReactNode;
}

export interface ModalComponentProps<DataT = never, TypeT = never> {
  open: boolean;
  handleClose: (val?: any) => void;
  type?: "ADD" | "UPDATE" | TypeT;
  data?: DataT;
  downloadPDF?: any;
}

export interface ApiErrorType {
  data: { message?: any };
}

export interface CommonParams {
  page?: number;
  limit?: number;
  skip?: number;
  status?: string;
  search?: string;
}

export interface GetQueryArgsType<ParamsT = never, HeadersT = never> {
  params?: ParamsT;
  headers?: HeadersT;
}

export interface PatchQueryArgsType<T = any> {
  body: T;
  id: string | number;
}

export type SidebarIconProps = {
  collapsed?: boolean;
};

export type CommonResponse<T> = {
  issuccess: boolean;
  statusCode: number;
  message: string;
  data: T;
};
